import api from './index'

import request from '@/utils/request'

// 手机号查询可退订单
export function ApiCustomerOrderGet(params) {
  return request({
    url: api.CustomerOrderGet + params.mobile,
    method: 'get',
    params: {},
    hideloading: true
  })
}

// 退款申请
export function ApiCustomerRefundApplySubmit(data) {
  return request({
    url: api.CustomerRefundApplySubmit,
    method: 'post',
    data: data,
    hideloading: true
  })
}

// 投诉提交
export function ApiCustomerComplaintSubmit(data) {
  return request({
    url: api.CustomerComplaintSubmit,
    method: 'post',
    data: data,
    hideloading: true
  })
}

// 手机号查询可退订单(全部订单)
export function ApiCustomerAllOrderGet(params) {
  return request({
    url: api.CustomerAllOrderGet + params.mobile,
    method: 'get',
    params: {},
    hideloading: true
  })
}

// 退款申请(全部订单)
export function ApiCustomerAllRefundApplySubmit(data) {
  return request({
    url: api.CustomerAllRefundApplySubmit,
    method: 'post',
    data: data,
    hideloading: true
  })
}

// 查询退款订单(全部订单)post请求
export function ApiCustomerGetRefundableOrders(data) {
  return request({
    url: api.CustomerGetRefundableOrders,
    method: 'post',
    data: data,
    hideloading: true
  })
}

// 查询并退款（支持php和java双平台）
export function ApiCustomerAutoRefund(data) {
  return request({
    url: api.CustomerAutoRefund,
    method: 'post',
    data: data,
    hideloading: true
  })
}

// 投诉并退款（支持php和java双平台）
export function ApiCustomerAutoComplaint(data) {
  return request({
    url: api.CustomerAutoComplaint,
    method: 'post',
    data: data,
    hideloading: true
  })
}